import { Link } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";

import FullWidthLayout from "./shared/FullWidthLayout";
import { APP_ROUTES } from "../constants/appRoutes";

export default function NotFound() {
    return (
        <FullWidthLayout>
            <div className="mx-auto flex min-h-[calc(100vh-14rem)] max-w-lg items-center justify-center py-8">
                <div className="w-full rounded-2xl border border-slate-200/80 bg-white/80 p-8 text-center shadow-lg backdrop-blur-sm md:p-12">
                    <p className="mb-4 text-7xl leading-none md:text-8xl" aria-hidden>
                        <i className="bi bi-calendar-x" aria-hidden />
                    </p>
                    <p className="mb-1 text-sm font-semibold uppercase tracking-[0.2em] text-slate-500">
                        404
                    </p>
                    <h1 className="mb-3 text-2xl font-bold tracking-tight text-red-900 md:text-3xl">
                        Page not found
                    </h1>
                    <p className="mb-8 text-sm leading-relaxed text-slate-600 md:text-base">
                        The page you&apos;re looking for doesn&apos;t exist or may have been moved.
                    </p>
                    <Link
                        to={APP_ROUTES.HOME}
                        className="btn btn-dark-app inline-flex items-center gap-2 px-5 py-2.5 text-sm font-semibold"
                    >
                        <i className="bi bi-house-door" aria-hidden />
                        Go to dashboard
                    </Link>
                </div>
            </div>
        </FullWidthLayout>
    );
}
